import { render, staticRenderFns } from "./BoxPoint.vue?vue&type=template&id=6b98447b&scoped=true&"
import script from "./BoxPoint.vue?vue&type=script&lang=js&"
export * from "./BoxPoint.vue?vue&type=script&lang=js&"
import style0 from "./BoxPoint.vue?vue&type=style&index=0&id=6b98447b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b98447b",
  null
  
)

export default component.exports